<div class="container h-100">
  <div class="row h-100 align-items-center">
    <div class="col">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
